import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { usePermissao } from './hooks/usePermissao';
import Login from './pages/Login/Login';
import TrocarSenha from './pages/Login/TrocarSenha';
import Dashboard from './pages/Dashboard/Dashboard';
import Estoque from './pages/Estoque/Estoque';
import Movimentacao from './pages/Movimentacao/Movimentacao';
import Historico from './pages/Movimentacao/Historico';
import OS from './pages/OS/OS';
import Cadastros from './pages/Cadastros/Cadastros';
import Produtos from './pages/Cadastros/Produtos/Produtos';
import Resinas from './pages/Cadastros/Resinas/Resinas';
import Usuarios from './pages/Cadastros/Usuarios/Usuarios';
import Estoques from './pages/Cadastros/Estoques/Estoques';
import Clientes from './pages/Cadastros/Clientes/Clientes';
import Relatorios from './pages/Relatorios';
import RelInventario from './pages/Relatorios/RelInventario';
import RelMinimo from './pages/Relatorios/RelMinimo';
import RelMovimentacoes from './pages/Relatorios/RelMovimentacoes';
import RelConsumoOS from './pages/Relatorios/RelConsumoOS';
import Configuracoes from './pages/Configuracoes/Configuracoes';
import Layout from './components/Layout/Layout';
import './styles/global.css';

// ============================================================
// RotaProtegida
// - Exige usuario logado
// - Se precisaTrocarSenha = true, redireciona para /trocar-senha
// - Se prop "acao" fornecida, checa na matriz do usePermissao.
//   Sem permissao -> redireciona para /dashboard (rota neutra que todos acessam)
// ============================================================
function RotaProtegida({ children, acao = null }) {
  const { usuario, precisaTrocarSenha } = useAuthStore();
  const { pode } = usePermissao();
  const location = useLocation();

  if (!usuario) return <Navigate to="/login" replace />;

  // Se precisa trocar senha e nao esta na tela de troca, forca ir pra la
  if (precisaTrocarSenha && location.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace />;
  }

  // Checagem de permissao por rota (defesa real contra acesso via URL direta)
  if (acao && !pode(acao)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/trocar-senha"
          element={
            <RotaProtegida>
              <TrocarSenha />
            </RotaProtegida>
          }
        />
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route element={<RotaProtegida><Layout /></RotaProtegida>}>
          {/* Telas acessiveis a todos os perfis logados */}
          <Route
            path="/dashboard"
            element={
              <RotaProtegida acao="verDashboard">
                <Dashboard />
              </RotaProtegida>
            }
          />
          <Route
            path="/estoque"
            element={
              <RotaProtegida acao="verEstoque">
                <Estoque />
              </RotaProtegida>
            }
          />
          <Route
            path="/os"
            element={
              <RotaProtegida acao="verOS">
                <OS />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios"
            element={
              <RotaProtegida acao="verRelatorios">
                <Relatorios />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/inventario"
            element={
              <RotaProtegida acao="verRelatorios">
                <RelInventario />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/minimo"
            element={
              <RotaProtegida acao="verRelatorios">
                <RelMinimo />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/movimentacoes"
            element={
              <RotaProtegida acao="verRelatorios">
                <RelMovimentacoes />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/consumo-os"
            element={
              <RotaProtegida acao="verRelatorios">
                <RelConsumoOS />
              </RotaProtegida>
            }
          />

          {/* Movimentacao: Gestor e Operador */}
          <Route
            path="/movimentacao"
            element={
              <RotaProtegida acao="verMovimentacao">
                <Movimentacao />
              </RotaProtegida>
            }
          />
          <Route
            path="/movimentacao/historico"
            element={
              <RotaProtegida acao="verHistorico">
                <Historico />
              </RotaProtegida>
            }
          />

          {/* Cadastros: somente Gestor */}
          <Route
            path="/cadastros"
            element={
              <RotaProtegida acao="verCadastros">
                <Cadastros />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastros/produtos"
            element={
              <RotaProtegida acao="verCadastros">
                <Produtos />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastros/resinas"
            element={
              <RotaProtegida acao="verCadastros">
                <Resinas />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastros/usuarios"
            element={
              <RotaProtegida acao="verCadastros">
                <Usuarios />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastros/estoques"
            element={
              <RotaProtegida acao="verCadastros">
                <Estoques />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastros/clientes"
            element={
              <RotaProtegida acao="verCadastros">
                <Clientes />
              </RotaProtegida>
            }
          />

          {/* Configuracoes: somente Gestor */}
          <Route
            path="/configuracoes"
            element={
              <RotaProtegida acao="verConfiguracoes">
                <Configuracoes />
              </RotaProtegida>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
